import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RiddleData } from 'entities'
import { ResponseCheckLetter } from 'services/api/riddles/entities'
import { onReject } from '../handler'
import { SecretWordState } from './entities'
import { getRiddleDataThunk, checkLetterThunk } from './thunk'

const REWARDED_TRIES = 3

const initialState: SecretWordState = {
    id: null,
    countLetters: 0,
    currentRiddle: '',
    currentSecretWord: [],
    isOpenWord: false,
    countOfError: 0,
    isStart: true,
    isResetProgressbar: false,
}

const secretWordSlice = createSlice({
    name: 'secretWord',
    initialState,
    reducers: {
      startProgressBar: (state) => {
        state.isResetProgressbar = false
        return state
      },
      addRewardedTries: (state) => {
        state.countOfError = state.countOfError - REWARDED_TRIES
        return state
      },
      startNewGame: (state) => {
        state.isStart = true
        return state
      },
    },
    extraReducers: (builder) => {
      builder.addCase(getRiddleDataThunk.fulfilled, (state, action: PayloadAction<RiddleData>) => {
        state.currentRiddle = action.payload.riddle
        state.id = action.payload.id
        state.countLetters = action.payload.countLetters
        state.currentSecretWord = []
        for(let i=0; i<action.payload.countLetters; i++) {
          state.currentSecretWord[i] = {
            symbol: '',
            isOpen: false
          }
        }            
        state.countOfError = 0
        state.isOpenWord = false
        state.isStart = false
        state.isResetProgressbar = true
        return state
      })
      builder.addCase(getRiddleDataThunk.rejected, (state, action) => {
        onReject(action.payload)
      })
      builder.addCase(checkLetterThunk.fulfilled, (state, action: PayloadAction<ResponseCheckLetter>) => {
        const {status, positions, letter} = action.payload
        if (status) {
          positions.forEach((position) => {
            state.currentSecretWord[position] = {
              symbol: letter,
              isOpen: true,
            }
          })
        } else {
          state.countOfError = state.countOfError + 1
        }
        state.isResetProgressbar = true
        state.isOpenWord = true
        Object.values(state.currentSecretWord).forEach((item) => {
          state.isOpenWord = state.isOpenWord && item.isOpen
        })
        return state
      })
      builder.addCase(checkLetterThunk.rejected, (state, action) => {
        onReject(action.payload);
      })
    },
})

export const {
  startProgressBar,
  addRewardedTries,
  startNewGame,
} = secretWordSlice.actions

export default secretWordSlice.reducer
